import clsx from 'clsx'
import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import styles from './main-layout.module.scss'
import { useCommonStore } from '../../common/stores/common.store'
import { RouteEnum } from '../../constants/routes.enum'
import { useProjectStore } from '../../entities/projects/stores/project.store'
import { MainHeader } from '../../modules/main/header/main.header'
import { MainSidebar } from '../../modules/main/sidebar/main.sidebar'

export const MainLayout: React.FC = () => {
  const location = useLocation()
  const { initAuthenticated } = useCommonStore()
  const projectStore = useProjectStore()
  useEffect(() => {
    initAuthenticated(projectStore)
  }, [])

  const hasProgress = location.pathname === `/${RouteEnum.ONBOARDING}`

  return (
    <div className={clsx(styles.mainLayout, 'd-flex h-100')}>
      <MainSidebar />
      <div className={clsx(styles.mainLayoutContent, 'h-100')}>
        <MainHeader hasProgress={hasProgress} />
        <div className={clsx(styles.mainLayoutWrapper, styles.mainLayoutWrapperDefault)}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
